<template>
  <slot
    :repository-name="name"
    :repository-owner="owner"
    :open-repositories-sheet="() => open = true"
  />
  <MobileSheet
    v-model:open="open"
    title="Switch repository"
  >
    <div class="px-3 pb-2 pt-1">
      <DSInputGroup>
        <DSInputGroupAddon>
          <SearchIcon />
        </DSInputGroupAddon>
        <DSInputGroupInput
          v-model="query"
          type="search"
          placeholder="Find a repository"
          aria-label="Find a repository"
        />
      </DSInputGroup>
    </div>
    <div class="px-3 pb-2 flex flex-col gap-0.5">
      <button
        v-for="repository in repositories"
        :key="repository.id"
        type="button"
        class="flex items-center gap-3 h-13 px-3 rounded-ds-md cursor-pointer"
        :class="repository.active ? 'bg-accent text-accent-foreground' : 'text-foreground'"
        @click="handleSelectRepository(repository.id)"
      >
        <FolderGit2Icon
          class="size-4.5 shrink-0"
          aria-hidden="true"
        />
        <span class="flex-1 min-w-0 text-left text-[15px] font-medium truncate">{{ repository.name }}</span>
        <CheckIcon
          v-if="repository.active"
          class="size-4.5 text-brand shrink-0"
          aria-hidden="true"
        />
      </button>
    </div>
    <div class="mx-3 pt-2 border-t border-border flex flex-col gap-0.5 pb-2">
      <DSButton
        type="button"
        variant="ghost"
        class="w-full gap-3 px-2.5 justify-start text-[15px] font-medium"
        @click="handleCreateRepository"
      >
        <PlusIcon
          class="size-4.5!"
          aria-hidden="true"
        />
        New repository
      </DSButton>
      <DSButton
        type="button"
        variant="ghost"
        class="w-full gap-3 px-2.5 justify-start text-foreground text-[15px] font-medium"
        @click="handleManageRepository"
      >
        <Settings2Icon
          class="size-4.5!"
          aria-hidden="true"
        />
        Manage repositories
      </DSButton>
    </div>
  </MobileSheet>
</template>

<script setup lang="ts">
import { useRepositories } from '../utils/useRepositories'

import MobileSheet from './MobileSheet.vue'
import { DSButton, DSInputGroup, DSInputGroupAddon, DSInputGroupInput } from '@ds'
import { CheckIcon, FolderGit2Icon, PlusIcon, SearchIcon, Settings2Icon } from '@lucide/vue'

const open = defineModel<boolean>('open', { default: false })

const { query, name, owner, repositories, handleSelect, handleCreate, handleManage } = useRepositories()

const handleSelectRepository = (id: string) => {
  handleSelect(id)
  open.value = false
}

const handleCreateRepository = () => {
  handleCreate()
  open.value = false
}

const handleManageRepository = () => {
  handleManage()
  open.value = false
}
</script>
